<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%"
      @expand-change="expanded"
      @selection-change="handleSelectionChange"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      ref="table"
      :expand-row-keys="expands"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <table class="table-box" style="width:100%" border="1" cellspacing="0">
            <tr>
              <th width="15%">
                <p>订单号</p>
                <p>流水号</p>
              </th>
              <th width="10%">创建时间</th>
              <th width="10%">业务</th>
              <th width="30%">产品名称</th>
              <th width="10%">金额</th>
              <th width="10%">状态</th>
              <th width="10%">操作</th>
            </tr>
            <tr v-for="(item,index) in detail" :key="index">
              <td>
                <p>{{item.orderNo}}</p>
                <p>{{item.flowNo}}</p>
              </td>
              <td width="12%">{{item.gmtCreate}}</td>
              <td>{{item.businessTypeText}}</td>
              <td>{{item.productName}}</td>
              <td>{{item.orderAmountText}}</td>
              <td>{{item.orderStatusText}}</td>
              <td>
                <!-- <el-button
                                    type="text"
                                    @click="repayment(item)"
                                    v-if="item.orderStatus!=2"
                >还款</el-button>-->

                <el-button type="text" @click="remark(item)">备注</el-button>
              </td>
            </tr>
          </table>
        </template>
      </el-table-column>
      <el-table-column type="selection" width="50" :selectable="checkboxInit"></el-table-column>
      <el-table-column label="账单日" width="200" prop="billDate"></el-table-column>
      <el-table-column label="账单金额" prop="billAmountText"></el-table-column>
      <el-table-column label="已还金额" prop="billPayedAmountText"></el-table-column>
      <el-table-column label="未还金额" prop="noPayedAmountText"></el-table-column>
      <el-table-column label="是否逾期" prop="isOverdue"></el-table-column>
      <el-table-column label="账单状态" prop="billStatusText"></el-table-column>
      <!-- <el-table-column label="操作" width="90">
        <template slot-scope="scope" v-if="scope.row.billStatus==1">
          <el-button size="mini" type="success" @click="repayment(scope.row)">还款</el-button>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>
<script>
import web_credit_creditBillDetail from "@/lib/data-service/default/web_credit_creditBillDetail";
import web_credit_creditBillRemark from "@/lib/data-service/default/web_credit_creditBillRemark";
export default {
  data() {
    return {
      expands: [],
      detail: []
    };
  },
  props: {
    tableData: {
      type: Array,
      default: []
    }
  },
  watch: {
    tableData(val) {
      if (val.length == 0) return;
      this.getDetail(val[0].id);
    }
  },
  methods: {
    remark(val) {
      this.$prompt("请输入备注信息", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: val.remark
      })
        .then(({ value }) => {
          web_credit_creditBillRemark({ billId: val.id, remark: value }).then(
            res => {
              res.code == this.SUCCESS_CODE
                ? this.$message({ type: "success", message: "修改成功！" })
                : "";
            }
          );
        })
        .catch(() => {});
    },
    checkboxInit(row) {
      const selectStatus = [1,3,4,6,7];
      if (selectStatus.includes(Number(row.billStatus))) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.$emit("getIds", ids);
    },
    repayment(item) {
      this.$router.push({ name: "distributor-credit-back-payment" });
    },
    expanded(row, expandedRows) {
      this.expands = [];
      expandedRows.length > 0 ? (row ? this.expands.push(row.id) : "") : "";
      this.getDetail(row.id);
    },
    getDetail(id) {
      web_credit_creditBillDetail({ billId: id }).then(res => {
        this.detail = res.results;
      });
    },
    getRowKeys(row) {
      return row.id;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table {
  font-size: 13px;
  .table-box {
    border-collapse: collapse;
    tr,
    td,
    th {
      text-align: center;
      border: 1px solid #dfdfdf;
      font-size: 13px;
    }
    td {
      padding: 8px;
    }
    .table-name {
      text-align: center;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      word-wrap: break-all;
    }
    .el-button {
      margin: 0;
    }
  }
}
.el-button {
  border-radius: 0;
}
</style>
